const dropFirstItem = (array) => {
  return array.slice(1);
};

export default dropFirstItem;



// WEBPACK FOOTER //
// ./src/scripts/drop-first-item.js